import { ReviewsIoStoreId } from 'config/constants/reviews-io';
import sharedEnvironment from 'config/shared-environment';
import { ShopId } from 'constants/shop';

const TRUSTED_SHOPS_ID = 'X49E4FB305D14765AEDA5BDF3FFA460F7';

/**
 * Environment values shared by dev, staging and production for the NL shop.
 */
// TODO: common env should be placed in the root of the config per locale
export default {
  ...sharedEnvironment,
  cookieDomain: '.petsdeli.nl',
  currencyCode: 'EUR',
  shopId: ShopId.NL,
  trustedShopsId: TRUSTED_SHOPS_ID,
  trustedShopsUrl: `https://www.trustedshops.nl/verkopersbeoordeling/info_${TRUSTED_SHOPS_ID}.html`,
  reviewsIoStoreId: ReviewsIoStoreId.NL,
};
